import type { WidgetComponent } from "@viz/presentation";

interface Kpi { label: string; value: string | number; unit?: string; tone?: "default" | "success" | "warning" | "danger" }

const TONE: Record<NonNullable<Kpi["tone"]>, string> = {
  default: "text-slate-900",
  success: "text-emerald-600",
  warning: "text-amber-600",
  danger:  "text-rose-600",
};

const KpiRow: WidgetComponent = ({ props }) => {
  const items = (props.items as Kpi[] | undefined) ?? [];
  return (
    <div className="grid grid-cols-2 gap-3 p-3 sm:grid-cols-4">
      {items.map((k, i) => (
        <div key={i} className="rounded-xl border border-slate-200 bg-slate-50 px-4 py-3">
          <div className="text-[11px] uppercase tracking-wider text-slate-500">{k.label}</div>
          <div className={`mt-1 text-2xl font-semibold ${TONE[k.tone ?? "default"]}`}>
            {k.value}
            {k.unit && <span className="ml-1 text-sm font-normal text-slate-500">{k.unit}</span>}
          </div>
        </div>
      ))}
    </div>
  );
};

export default KpiRow;
